export default function Reviews() {
  const reviews = [
    {
      name: 'Michael Schmidt',
      location: 'Munich, Germany',
      flag: '🇩🇪',
      car: 'BMW M4 Competition',
      rating: 5,
      text: 'The fitment is absolutely perfect. Every piece aligned flawlessly with OEM mounting points. The carbon weave is stunning and the weight savings are noticeable. Worth every euro.',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20confident%20male%20car%20enthusiast%20in%20his%2030s%20wearing%20black%20casual%20clothing%20against%20dark%20background%20with%20subtle%20lighting%20automotive%20customer%20testimonial%20photo&width=200&height=200&seq=avatar1&orientation=squarish',
      verified: true
    },
    {
      name: 'James Rodriguez',
      location: 'Los Angeles, USA',
      flag: '🇺🇸',
      car: 'Porsche 911 GT3',
      rating: 5,
      text: 'Track-tested these parts at Laguna Seca. The aerodynamic improvements are real—gained 2 seconds per lap. Build quality exceeds OEM standards. Highly recommended.',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20confident%20male%20car%20enthusiast%20in%20his%2040s%20wearing%20black%20casual%20clothing%20against%20dark%20background%20with%20subtle%20lighting%20automotive%20customer%20testimonial%20photo&width=200&height=200&seq=avatar2&orientation=squarish',
      verified: true
    },
    {
      name: 'Sophie Laurent',
      location: 'Paris, France',
      flag: '🇫🇷',
      car: 'Mercedes-AMG GT',
      rating: 5,
      text: 'Exceptional craftsmanship. The glossy finish is mirror-like and the attention to detail is remarkable. Installation was straightforward with included hardware. My AMG looks incredible.',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20confident%20female%20car%20enthusiast%20in%20her%2030s%20wearing%20black%20casual%20clothing%20against%20dark%20background%20with%20subtle%20lighting%20automotive%20customer%20testimonial%20photo&width=200&height=200&seq=avatar3&orientation=squarish',
      verified: true
    },
    {
      name: 'David Chen',
      location: 'Hong Kong',
      flag: '🇭🇰',
      car: 'Audi RS6 Avant',
      rating: 5,
      text: 'Best carbon fiber parts I\'ve purchased. The weave pattern is consistent across all pieces and the clear coat is flawless. Customer service was excellent throughout.',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20confident%20male%20car%20enthusiast%20in%20his%2030s%20wearing%20black%20casual%20clothing%20against%20dark%20background%20with%20subtle%20lighting%20automotive%20customer%20testimonial%20photo&width=200&height=200&seq=avatar4&orientation=squarish',
      verified: true
    },
    {
      name: 'Marco Bianchi',
      location: 'Milan, Italy',
      flag: '🇮🇹',
      car: 'BMW M2 CS',
      rating: 5,
      text: 'Transformed my M2 completely. The carbon fiber adds an aggressive look while reducing weight. Quality is outstanding and shipping was fast. Will order more parts soon.',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20confident%20male%20car%20enthusiast%20in%20his%2040s%20wearing%20black%20casual%20clothing%20against%20dark%20background%20with%20subtle%20lighting%20automotive%20customer%20testimonial%20photo&width=200&height=200&seq=avatar5&orientation=squarish',
      verified: true
    },
    {
      name: 'Emma Wilson',
      location: 'London, UK',
      flag: '🇬🇧',
      car: 'Porsche Cayman GT4',
      rating: 5,
      text: 'Absolutely brilliant. The carbon fiber is genuine and the finish is impeccable. Installation instructions were clear and all mounting points lined up perfectly. Five stars.',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20confident%20female%20car%20enthusiast%20in%20her%2030s%20wearing%20black%20casual%20clothing%20against%20dark%20background%20with%20subtle%20lighting%20automotive%20customer%20testimonial%20photo&width=200&height=200&seq=avatar6&orientation=squarish',
      verified: true
    }
  ];

  const pressLogos = [
    { name: 'EVO Magazine', width: 'w-28' },
    { name: 'Top Gear', width: 'w-32' },
    { name: 'AutoBild', width: 'w-28' },
    { name: 'Car & Driver', width: 'w-36' },
    { name: 'Motor Trend', width: 'w-32' }
  ];

  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8">
        {/* Stats Row */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12 md:mb-20">
          <div className="text-center p-5 md:p-8 bg-gray-50 border border-gray-200">
            <div className="flex items-center justify-center gap-1 md:gap-2 mb-2 md:mb-3">
              <span className="text-3xl md:text-5xl font-black text-black">4.9</span>
              <i className="ri-star-fill text-black text-xl md:text-3xl"></i>
            </div>
            <div className="text-gray-600 text-xs font-semibold uppercase tracking-wider">Average Rating</div>
          </div>
          <div className="text-center p-5 md:p-8 bg-gray-50 border border-gray-200">
            <div className="text-3xl md:text-5xl font-black text-black mb-2 md:mb-3">2,500+</div>
            <div className="text-gray-600 text-xs font-semibold uppercase tracking-wider">Customer Reviews</div>
          </div>
          <div className="text-center p-5 md:p-8 bg-gray-50 border border-gray-200">
            <div className="text-3xl md:text-5xl font-black text-black mb-2 md:mb-3">98%</div>
            <div className="text-gray-600 text-xs font-semibold uppercase tracking-wider">Recommend Us</div>
          </div>
          <div className="text-center p-5 md:p-8 bg-gray-50 border border-gray-200">
            <div className="text-3xl md:text-5xl font-black text-black mb-2 md:mb-3">40+</div>
            <div className="text-gray-600 text-xs font-semibold uppercase tracking-wider">Countries Shipped</div>
          </div>
        </div>

        {/* Section Title */}
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-black text-black mb-3 md:mb-4 tracking-tight">CUSTOMER REVIEWS</h2>
          <p className="text-gray-600 text-base md:text-lg">Real feedback from real enthusiasts</p>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-8 mb-12 md:mb-20">
          {reviews.map((review, index) => (
            <div
              key={index}
              className="bg-white border-2 border-gray-200 p-5 md:p-8 hover:border-black transition-all duration-300 group"
            >
              {/* Rating */}
              <div className="flex gap-1 mb-4 md:mb-6">
                {[...Array(review.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-black text-lg md:text-xl"></i>
                ))}
              </div>

              {/* Review Text */}
              <p className="text-gray-800 text-base md:text-lg leading-relaxed mb-6 md:mb-8 font-medium">
                "{review.text}"
              </p>

              {/* Author Info */}
              <div className="flex items-start gap-3 md:gap-4 mb-4 md:mb-6">
                <div className="w-12 h-12 md:w-16 md:h-16 rounded-full overflow-hidden border-2 border-gray-300 group-hover:border-black transition-colors flex-shrink-0">
                  <img
                    src={review.avatar}
                    alt={review.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1">
                  <div className="text-black font-bold text-base md:text-lg mb-1">{review.name}</div>
                  <div className="text-gray-600 text-xs md:text-sm flex items-center gap-2">
                    <span>{review.flag}</span>
                    <span>{review.location}</span>
                  </div>
                </div>
              </div>

              {/* Car Model Badge */}
              <div className="flex items-center justify-between pt-4 md:pt-6 border-t border-gray-200">
                <div className="bg-black text-white px-3 py-1.5 md:px-4 md:py-2 text-xs font-bold uppercase tracking-wider">
                  {review.car}
                </div>
                {review.verified && (
                  <div className="flex items-center gap-1 md:gap-2 text-green-600">
                    <i className="ri-checkbox-circle-fill text-base md:text-lg"></i>
                    <span className="text-xs font-semibold uppercase">Verified</span>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Featured In Press Strip */}
        <div className="mb-10 md:mb-16">
          <div className="text-center mb-6 md:mb-10">
            <h3 className="text-sm font-bold uppercase tracking-[3px] text-gray-500">AS FEATURED IN</h3>
          </div>
          <div className="flex items-center justify-center gap-4 md:gap-12 flex-wrap opacity-40 grayscale">
            {pressLogos.map((logo, index) => (
              <div key={index} className={`${logo.width} h-10 md:h-12 bg-black flex items-center justify-center`}>
                <span className="text-white font-black text-xs uppercase tracking-wider">{logo.name}</span>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Button */}
        <div className="text-center">
          <button className="group inline-flex items-center gap-3 bg-black text-white px-7 md:px-10 py-4 md:py-5 text-sm md:text-base font-bold uppercase tracking-wider hover:bg-gray-900 transition-all whitespace-nowrap cursor-pointer">
            Read All Reviews on Trustpilot
            <i className="ri-arrow-right-line text-lg md:text-xl group-hover:translate-x-2 transition-transform"></i>
          </button>
        </div>
      </div>
    </section>
  );
}